/**
 * Les photographies de l'accueil, declarees en un seul endroit.
 *
 * L'accueil affichait onze images : trois dans le carrousel, six sur les
 * tuiles de categorie, une dans la maquette telephone, une dans le repli de
 * la mise en avant produit. Aucune n'etait une photo d'ABBUSINESS. Toutes
 * venaient d'images.unsplash.com, et celles des categories etaient meme
 * inscrites en base par le seed : un visiteur voyait un salon americain
 * legende « Salons & Canapés » et un magasin d'electromenager qui n'est pas
 * le notre.
 *
 * D'ou ce fichier. Une entree vaut null jusqu'a ce que la photo reelle soit
 * deposee ; les composants ne rendent alors aucune balise <img> et se
 * replient sur une tuile typographique. Aucune photo de banque ne peut
 * revenir par accident, parce qu'il n'y en a plus une seule a copier.
 *
 * Pour ajouter une photo, deux gestes :
 *   1. deposer le fichier dans public/images/… sous le nom indique ;
 *   2. remplacer le null par ce chemin, sans le prefixe « public ».
 *
 * PHOTOS.md donne le cadrage, le format et le nombre attendus pour chaque
 * poste. visuels.test.js verifie qu'aucun chemin declare ici ne pointe vers
 * un fichier absent : une image annoncee et manquante casserait l'accueil
 * en silence, et c'est exactement le defaut que ce fichier existe pour
 * empecher. Il refuse aussi toute adresse de banque d'images.
 */

/**
 * Une photo par categorie, clef = slug de la categorie en base.
 *
 * Ces sept slugs sont ceux de la table categories. Une categorie absente
 * de cet objet, ou dont la valeur est null, s'affiche en tuile
 * typographique : c'est un etat prevu, pas une panne.
 */
export const PHOTOS_CATEGORIES = {
  salons:         null,   // public/images/categories/salons.webp
  chambres:       null,   // public/images/categories/chambres.webp
  decoration:     null,   // public/images/categories/decoration.webp
  electromenager: null,   // public/images/categories/electromenager.webp
  massage:        null,   // public/images/categories/massage.webp
  sport:          null,   // public/images/categories/sport.webp
  rideaux:        null,   // public/images/categories/rideaux.webp
}

/**
 * Le diaporama de l'ouverture.
 *
 * L'ordre du tableau est l'ordre d'affichage. La premiere photo est celle
 * qui se charge en priorite : c'est le plus grand element du premier ecran,
 * donc celle qui decide de la vitesse percue du site. Y mettre la meilleure,
 * et la plus legere.
 *
 * Le tableau est vide tant qu'aucune photo n'est deposee, et l'ouverture
 * passe alors en pleine largeur. Un cadre vide serait pire.
 *
 * Ce qui a sa place ici : le magasin en activite, une realisation installee
 * chez un client, une livraison ou une installation en cours. Ce qui n'y a
 * pas sa place : une photo de banque d'images, un rendu de synthese, et une
 * prise de vue produit sur fond blanc — celle-la appartient a la fiche du
 * produit, et la mise en avant l'affiche deja plus bas.
 *
 * Pour ajouter une photo, deux gestes :
 *   1. deposer le fichier dans public/images/accueil/ ;
 *   2. ajouter une entree ici, avec sa legende en francais et en anglais.
 *
 * @type {{ fichier: string, legende: { fr: string, en: string } }[]}
 */
export const DIAPORAMA_ACCUEIL = [
  // {
  //   fichier: '/images/accueil/showroom-hamdallaye.webp',
  //   legende: {
  //     fr: 'Notre magasin de Hamdallaye, Conakry',
  //     en: 'Our Hamdallaye store, Conakry',
  //   },
  // },
]

/**
 * Le chemin d'une photo de categorie, ou null.
 *
 * Priorite a image_url quand la base en porte un : c'est la valeur que
 * l'administrateur peut changer depuis le panel. Ce fichier ne sert que de
 * relais pour les photos versionnees avec le site. L'inverse aurait fait un
 * champ d'administration sans effet visible, c'est-a-dire un mensonge de
 * plus dans l'interface.
 */
export function photoDeCategorie(categorie) {
  if (categorie?.image_url) return categorie.image_url

  return PHOTOS_CATEGORIES[categorie?.slug] ?? null
}
